import { useUsers } from "@/entities/user/useUser"
import { Link } from "react-router-dom"

export default function DebugAttendancesIndex() {
   const { data: users } = useUsers()

   if (!users) return <div>Loading...</div>

   const youngs = users.filter((user) => user.role === "young")

   return (
      <div className="p-4">
         <button
            type="button"
            className="btn btn-error"
            onClick={() => {
               throw new Error("Sentry Test Error")
            }}
         >
            Test Sentry Error
         </button>

         <h1 className="text-2xl font-bold mb-4">Sélectionner un jeune</h1>
         <div className="grid gap-4">
            {youngs.map((young) => (
               <Link
                  key={young.id}
                  to={`/dbg-attendances/${young.id}`}
                  className="p-4 border rounded hover:bg-base-200"
               >
                  {young.firstName} {young.lastName}
               </Link>
            ))}
         </div>
      </div>
   )
}
